import { render, staticRenderFns } from "./ScaleProductsTable.vue?vue&type=template&id=57b64ff7&scoped=true"
import script from "./ScaleProductsTable.vue?vue&type=script&lang=js"
export * from "./ScaleProductsTable.vue?vue&type=script&lang=js"
import style0 from "./ScaleProductsTable.vue?vue&type=style&index=0&id=57b64ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b64ff7",
  null
  
)

export default component.exports